export interface SaaeLogoProps {
  className?: string;
  /** Visual style (for future use if a dark logo asset is added) */
  mode?: 'light' | 'dark';
  size?: 'large' | 'medium' | 'small' | 'xsmall';
  /** Use full logo or icon-only (e.g. for collapsed sidebar) */
  variant?: 'full' | 'icon';
}

const sizeClasses = {
  large: 'h-14',
  medium: 'h-11',
  small: 'h-9',
  xsmall: 'h-7',
} as const;

const sizeDimensions = {
  large: { width: 277, height: 58 },
  medium: { width: 211, height: 44 },
  small: { width: 173, height: 36 },
  xsmall: { width: 134, height: 28 },
} as const;

import logoSrc from '../../public/images/Saae_Logo.svg';
import iconSrc from '../../public/images/Saae_icon.svg';

export function SaaeLogo({ className, mode: _mode = 'light', size = 'large', variant = 'full' }: SaaeLogoProps) {
  const { width, height } = sizeDimensions[size];
  if (variant === 'icon') {
    return (
      <img
        src={iconSrc}
        alt="Sa3ee"
        className={`block h-8 w-8 shrink-0 ${className ?? ''}`.trim()}
        width={32}
        height={32}
      />
    );
  }
  return (
    <img
      src={logoSrc}
      alt="Sa3ee"
      className={`block w-auto ${sizeClasses[size]} ${className ?? ''}`.trim()}
      width={width}
      height={height}
    />
  );
}
